<template>
  <div>
    <div class="form-group">
        <label class="col-sm-2 control-label">姓名</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="姓名" v-model="user.profile.name">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">手机</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="手机" v-model="user.profile.phone">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">地址</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="地址" v-model="user.profile.address">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">性别</label>
        <div class="col-sm-10">
          <select class="form-control" v-model="user.profile.sex">
            <option value="女">女</option>
            <option value="男">男</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">卡号</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="卡号" v-model="user.profile.vipID">
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['user']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/Vip.vue